import theme from '../../../lib/theme';
import { StickyAcquisitionProps } from './StickyAcquisition';

const {
  layouts,
  layers,
  colors,
  media,
} = theme;

export default ({ collapsed }: StickyAcquisitionProps) => ({
  container: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    margin: 0,
    width: '100vw',
    height: collapsed ? 0 : 56,
    overflow: collapsed ? 'hidden' : 'unset',
    opacity: collapsed ? 0 : 1,
    transition: 'all 150ms ease',
    zIndex: layers.high,
  },

  acquisition: {
    ...layouts.row,

    height: '100%',
    backgroundColor: colors.sas.primary,
  },

  [media.l.up]: {
    display: 'none',
  },
});
